var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "diglog-card",
      attrs: {
        title: _vm.$t("send_pagements.create_small_value_payment"),
        visible: _vm.dialogTableVisible,
        width: "540px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogTableVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "header-line" }),
      _c("div", { staticClass: "section-title" }),
      _c(
        "div",
        { staticStyle: { margin: "0 12px" } },
        [
          _c("el-form", [
            _c("h2", { staticClass: "font_size_title" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.account_details"))),
            ]),
            _c(
              "div",
              {
                class: {
                  "account-details-row": _vm.$store.getters.isAllCountry,
                },
              },
              [
                _vm.$store.getters.isAllCountry
                  ? _c("el-form-item", { staticClass: "currency-form-item" }, [
                      _c(
                        "div",
                        { staticClass: "currency-form-content" },
                        [
                          _c("span", { staticClass: "currency-label" }, [
                            _vm._v(_vm._s(_vm.$t("data.currency")) + ":"),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "currency-select",
                              attrs: { clearable: "" },
                              on: { change: _vm.onCurrencyChange },
                              model: {
                                value: _vm.currency,
                                callback: function ($$v) {
                                  _vm.currency = $$v
                                },
                                expression: "currency",
                              },
                            },
                            _vm._l(
                              _vm.$store.state.page.countryArr,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.currency,
                                    value: item.currency,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("merchantAccount.available_balance") + ":",
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "#3855F1" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("toDivideWithDot")(_vm.total_balance)) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "singleDisbursementModal" }, [
            _c("h2", { staticClass: "payout-second-title" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.beneficiary_details"))),
            ]),
            _c(
              "div",
              { staticClass: "form-container" },
              [
                _c(
                  "el-form",
                  {
                    ref: "singleDisbursementForm",
                    attrs: {
                      model: _vm.singleDisbursementForm,
                      "status-icon": "",
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _vm.showReceivingChannel
                          ? _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "merchantAccount.receiving_channel"
                                      ),
                                      prop: "code",
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Receiving channel cannot be empty",
                                          trigger: "blur",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "select-item",
                                        attrs: {
                                          placeholder:
                                            "Select receiving channel",
                                          filterable: "",
                                          clearable: "",
                                        },
                                        on: {
                                          change: _vm.disbursementChannelChange,
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm.code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.receivingChannelList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.name_with_full_bank,
                                              value: item.bank_code,
                                              alt: item.name_with_full_bank,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showBeneficiaryAccountType
                          ? _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "merchantAccount.beneficiary_account_type"
                                      ),
                                      prop: "beneficiary_account_type",
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Beneficiary account type cannot be empty",
                                          trigger: "blur",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "select-item",
                                        attrs: {
                                          placeholder:
                                            "Select beneficiary account type",
                                          filterable: "",
                                          clearable: "",
                                        },
                                        on: {
                                          change:
                                            _vm.beneficiaryAccountTypeChange,
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .beneficiary_account_type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "beneficiary_account_type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.beneficiary_account_type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.beneficiaryAccountType,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                              alt: item.label,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showBeneficiaryType
                          ? _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.beneficiaryTypeLabel,
                                      prop: "beneficiary_type",
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Beneficiary type cannot be empty",
                                          trigger: "blur",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "select-item",
                                        attrs: {
                                          placeholder:
                                            "Select beneficiary type",
                                          filterable: "",
                                          clearable: "",
                                        },
                                        on: {
                                          change: _vm.beneficiaryTypeChange,
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .beneficiary_type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "beneficiary_type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.beneficiary_type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.beneficiaryTypeOptions,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                              alt: item.label,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isRUCountry
                          ? _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "merchantAccount.beneficiary_category"
                                      ),
                                      prop: "beneficiary_category",
                                      rules: [
                                        {
                                          required: true,
                                          message: _vm.$t(
                                            "merchantAccount.beneficiary_category_required"
                                          ),
                                          trigger: "change",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "select-item",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "merchantAccount.beneficiary_category_placeholder"
                                          ),
                                          filterable: "",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .beneficiary_category,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "beneficiary_category",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.beneficiary_category",
                                        },
                                      },
                                      _vm._l(
                                        _vm.beneficiaryCategoryOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "merchantAccount.beneficiary_name"
                                  ),
                                  prop: "account_name",
                                  rules: [
                                    {
                                      required: true,
                                      message:
                                        "Beneficiary Name cannot be empty",
                                      trigger: "blur",
                                    },
                                    {
                                      validator: _vm.checkWhitespace,
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    placeholder: "Enter beneficiary name",
                                    autocomplete: "off",
                                    clearable: "",
                                    maxlength: "40",
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value:
                                      _vm.singleDisbursementForm.account_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "account_name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "singleDisbursementForm.account_name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "merchantAccount.beneficiary_account_no"
                                  ),
                                  prop: "account_no",
                                  rules: [
                                    {
                                      required: true,
                                      message:
                                        "Beneficiary Account No. cannot be empty",
                                      trigger: ["blur", "change"],
                                    },
                                    {
                                      validator: _vm.checkoutAccountNo,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    placeholder:
                                      "Enter beneficiary account no.",
                                    autocomplete: "off",
                                    clearable: "",
                                    maxlength: "50",
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value:
                                      _vm.singleDisbursementForm.account_no,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "account_no",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "singleDisbursementForm.account_no",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "customerService.beneficiary_mobile"
                                  ),
                                  prop: "mobile",
                                  rules: [
                                    {
                                      required: _vm.currentCountryCode === "ID",
                                      message:
                                        "Please input the correct mobile",
                                      trigger: ["blur", "change"],
                                    },
                                    {
                                      validator: _vm.checkMobile,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    placeholder: "Enter beneficiary mobile",
                                    autocomplete: "off",
                                    clearable: "",
                                    maxlength:
                                      _vm.getStandardPaymentLimitMapMobileLength(
                                        _vm.currentCountryCode
                                      ),
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value: _vm.singleDisbursementForm.mobile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "mobile",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "singleDisbursementForm.mobile",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "customerService.email_address"
                                  ),
                                  prop: "email",
                                  rules: [
                                    {
                                      type: "email",
                                      message: "Please input the correct email",
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    placeholder: "Enter email address",
                                    autocomplete: "off",
                                    maxlength: "50",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.singleDisbursementForm.email,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "email",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "singleDisbursementForm.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.currentCountryCode === "AE"
                          ? _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("map.benefit_address"),
                                      prop: "beneficiary_address",
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Beneficiary address cannot be empty",
                                          trigger: ["blur", "change"],
                                        },
                                        { trigger: ["blur", "change"] },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "tips.beneficiary_address_name_exceed_140"
                                        ),
                                        type: "textarea",
                                        rows: 3,
                                        autocomplete: "off",
                                        maxlength: "140",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value:
                                          _vm.singleDisbursementForm
                                            .beneficiary_address,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.singleDisbursementForm,
                                            "beneficiary_address",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "singleDisbursementForm.beneficiary_address",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isGulfCountry
                          ? [
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_iban"
                                        ),
                                        prop: "iban",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Beneficiary IBAN cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder: "Enter beneficiary IBAN",
                                          autocomplete: "off",
                                          maxlength: "100",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm.iban,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "iban",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.iban",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_swift_code"
                                        ),
                                        prop: "swift_code",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "SWIFT Code cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder: "Enter SWIFT code",
                                          autocomplete: "off",
                                          maxlength: "50",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .swift_code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "swift_code",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.swift_code",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_bank_address"
                                        ),
                                        prop: "bank_address",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Beneficiary bank address cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder:
                                            "Enter beneficiary bank address",
                                          autocomplete: "off",
                                          maxlength: "200",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .bank_address,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "bank_address",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.bank_address",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_en_first_name"
                                        ),
                                        prop: "en_first_name",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Beneficiary English first name cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder:
                                            "Enter beneficiary English first name",
                                          autocomplete: "off",
                                          maxlength: "100",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .en_first_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "en_first_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.en_first_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_en_last_name"
                                        ),
                                        prop: "en_last_name",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Beneficiary English last name cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder:
                                            "Enter beneficiary English last name",
                                          autocomplete: "off",
                                          maxlength: "100",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .en_last_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "en_last_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.en_last_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_native_first_name"
                                        ),
                                        prop: "local_first_name",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Beneficiary native first name cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder:
                                            "Enter beneficiary native first name",
                                          autocomplete: "off",
                                          maxlength: "100",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .local_first_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "local_first_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.local_first_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "merchantAccount.beneficiary_native_last_name"
                                        ),
                                        prop: "local_last_name",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Beneficiary native last name cannot be empty",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "search-frame",
                                        attrs: {
                                          placeholder:
                                            "Enter beneficiary native last name",
                                          autocomplete: "off",
                                          maxlength: "100",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.singleDisbursementForm
                                              .local_last_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.singleDisbursementForm,
                                              "local_last_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "singleDisbursementForm.local_last_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c("el-col", [
                          _c("div", [
                            _c(
                              "h2",
                              { staticClass: "payout-second-title mt-12" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("merchantAccount.payment_details")
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "merchantAccount.merchant_order_id"
                                  ),
                                  prop: "merchant_order_id",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    maxlength: "32",
                                    "show-word-limit": "",
                                    placeholder: "Enter merchant order ID",
                                    type: "text",
                                    autocomplete: "off",
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.singleDisbursementForm
                                        .merchant_order_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "merchant_order_id",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression:
                                      "singleDisbursementForm.merchant_order_id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.amountTips,
                                  prop: "amount",
                                  rules: [
                                    {
                                      required: true,
                                      message: "Amount cannot be empty",
                                      trigger: ["blur", "change"],
                                    },
                                    {
                                      validator: _vm.checkAmount,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Enter amount",
                                    autocomplete: "off",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.singleDisbursementForm.amount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "amount",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "singleDisbursementForm.amount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("merchantAccount.payment_remark") +
                                    ":",
                                  prop: "remark",
                                  rules: [
                                    {
                                      required: _vm.currentCountryCode === "AE",
                                      message: "Payment remark cannot be empty",
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Enter your message here",
                                    type: "textarea",
                                    autocomplete: "off",
                                    maxlength: "256",
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value: _vm.singleDisbursementForm.remark,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "remark",
                                        $$v
                                      )
                                    },
                                    expression: "singleDisbursementForm.remark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.$store.getters.isOpenMfa
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("system.mfa_verify_code"),
                                      prop: "mfa_code",
                                      rules: [
                                        {
                                          validator: _vm.validateVerifyCode,
                                          trigger: ["blur", "change"],
                                        },
                                      ],
                                      required: "",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-password",
                                      attrs: {
                                        maxlength: "6",
                                        placeholder:
                                          "Enter your MFA verification code",
                                        autocomplete: "off",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value:
                                          _vm.singleDisbursementForm.mfa_code,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.singleDisbursementForm,
                                            "mfa_code",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "singleDisbursementForm.mfa_code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "cp-btn" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "cancel-btn",
                    on: { click: _vm.onClickCancelBtn },
                  },
                  [_vm._v(_vm._s(_vm.$t("components.cancel")))]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "confirm-btn",
                    attrs: { type: "info", disabled: _vm.submiting },
                    on: { click: _vm.onClickSubmitBtn },
                  },
                  [_vm._v(_vm._s(_vm.$t("components.confirm")))]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }